/*
 * @Author: COCO
 * @Date: 2019-04-11 11:32:52
 * @Last Modified by: COCO
 * @Last Modified time: 2019-05-23 14:31:34
 */
export default {
  requestAnimationQuee: [],
  loading: false,
  rAF(callback) {
    this.requestAnimationQuee.push(callback);
    if (!this.loading) {
      this.loading = true;
      this.start(this.shift());
    }
  },
  shift() {
    return this.requestAnimationQuee.shift();
  },
  start(callback) {
    requestAnimationFrame(() => {
      try {
        callback();
      } catch (e) {
        console.warn(e.message);
      }
      if (this.requestAnimationQuee.length) {
        this.start(this.shift());
      } else {
        this.loading = false;
      }
    });
  }
};



// WEBPACK FOOTER //
// ./src/utils/rAF.js